function formatAppVersion(rawVersion: string | undefined) {
  if (!rawVersion) return "0.000";

  const formattedVersion = rawVersion.match(/^(\d+)\.(\d{3})$/);
  if (formattedVersion) return rawVersion;

  const incrementalVersion = Number(rawVersion);
  if (!Number.isInteger(incrementalVersion) || incrementalVersion < 0) {
    return "0.000";
  }

  const majorVersion = import.meta.env.VITE_APP_VERSION_MAJOR ?? "0";
  return `${majorVersion}.${String(incrementalVersion).padStart(3, "0")}`;
}

const APP_VERSION = formatAppVersion(import.meta.env.VITE_APP_VERSION);

export { APP_VERSION };
